import React from 'react';
import CellFactory from '../../CellFactory';
import Document from '../../Cell/Document';
import Number from '../../Cell/Number';
import Text from '../../Cell/Text';
import DocumentList from '../../Cell/DocumentList';

const ALevelFurther = ({ row }) => {
  const {
    aLevelFurtherColumnOne,
    aLevelFurtherColumnTwo,
    aLevelFurtherChapter,
    aLevelFurtherColumnFour,
    aLevelFurtherColumnFive,
    aLevelFurtherColumnSix,
    aLevelFurtherColumnNine,
    aLevelFurtherColumnTwelve,
    aLevelFurtherColumnThirteen,
    aLevelFurtherColumnFourteen,
    aLevelFurtherColumnFifteen,
    aLevelFurtherColumnSixteen,
  } = row;
  return (
    <tr>
      <td>{aLevelFurtherColumnOne}</td>
      <td>
        <Number
          block={{
            value: aLevelFurtherChapter,
            displayAs: 'chapter',
          }}
        />
      </td>
      <td>
        <CellFactory cells={aLevelFurtherColumnTwo} />
      </td>
      <td>
        <CellFactory cells={aLevelFurtherColumnFour} />
      </td>
      <td>
        <Number
          block={{
            value: aLevelFurtherColumnFive,
            displayAs: 'percent',
          }}
        />
      </td>
      <td>
        <DocumentList documents={aLevelFurtherColumnSix} />
      </td>
      <td>
        <Document document={aLevelFurtherColumnNine} />
      </td>
      <td>
        <Document document={aLevelFurtherColumnTwelve} />
      </td>
      <td>
        <Document document={aLevelFurtherColumnThirteen} />
      </td>
      <td>
        <Document document={aLevelFurtherColumnFifteen} />
      </td>
      <td>
        <Document document={aLevelFurtherColumnSixteen} />
      </td>
      <td>
        <Text
          isVideoExplanation
          block={{
            body: aLevelFurtherColumnFourteen,
          }}
        />
      </td>
    </tr>
  );
};

export default ALevelFurther;
